export default "__VITE_ASSET__CMYtuTc3__"